/* © Facilogi. See COPYRIGHT file for full copyright & licensing details. */

import BaseModel from "./Model";

export type PaymentStatus = "Succeeded" | "Processing" | "Incomplete" | "Canceled";

export default interface BasePayment extends BaseModel {
    ExternalId?: string;
    /* Amount in the main currency unit (euros), already divided by 100. */
    Amount?: number;
    Currency?: string;
    Status?: PaymentStatus;
    /* Creation timestamp in seconds (Stripe `created`). */
    CreatedAt?: number;
    CustomerName?: string;
    CustomerEmail?: string;
    Description?: string;
}
